export const SET_DATA_TYPES = 'data-types/set-data-types';
export const REMOVE_DATA_TYPE = 'data-types/remove-data-type';
export const REMOVE_ATTRIBUTE = 'data-types/remove-attribute';
export const SET_ATTRIBUTES = 'data-types/set-attributes';
export const SET_SELECTED_DATA_TYPE = 'data-types/set-selected-data-type';
export const SET_SELECTED_ATTRIBUTE_FOR_DATATYPE = 'data-types/set-selected-attribute-for-data-type';
export const SET_SELECTED_ATTRIBUTE = 'data-types/set-selected-attribute';
export const SET_SELECTED = 'data-types/set-selected';
export const MOVE_ATTRIBUTE_UP = 'data-types/move-attribute-up';
export const MOVE_ATTRIBUTE_DOWN = 'data-types/move-attribute-down';
export const SET_DATA_TYPE_REFERENCE_STATUS = 'data-types/set-reference-status';
export const SET_ACTION_MODE = 'data-types/set-action-mode';
export const REMOVE_ATTRIBUTE_FROM_COMPOSITE = 'data-types/remove-attribute-from-composite';
export const MOVE_ATTRIBUTE_FROM_COMPOSITE = 'data-types/move-attribute-from-composite';
export const SET_NEW_ATTRIBUTE_COMPOSITE = 'data-types/set-new-attribute-composite';
